import { render, staticRenderFns } from "./Player.vue?vue&type=template&id=b8c69e92"
import script from "./Player.vue?vue&type=script&lang=ts"
export * from "./Player.vue?vue&type=script&lang=ts"
import style0 from "./Player.vue?vue&type=style&index=0&id=b8c69e92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports